/**
 * Resource-Chains-Org-Frontend Project
 * AddUserForGroup/index.ts
 * Copyright © CITYNOW Co. Ltd. All rights reserved.
 */
import { AXIOS_INSTANCE, QT_API } from "../config";
import {
  GET_QUOTA_REQUEST,
  GET_QUOTA_SUCCESS,
  GET_QUOTA_ERROR,
} from "../constants/actionTypes";

/**
 * Action add user into group
 * @author Tran Nhut Kha [nhutkha.tran@citynow.vn]
 * @since <Added Date or Version>
 */

export const GetQuota =
  ({ data = {}, params = {}, cbSuccess, cbError } = {}) =>
  (dispatch) => {
    dispatch({
      type: GET_QUOTA_REQUEST,
    });
    return AXIOS_INSTANCE.request({
      url: `${QT_API}/quota/${params.orgCode}/get-expired?serviceCode=${params.serviceCode}`,
      method: "GET",
    })
      .then((res) => {
        dispatch({
          type: GET_QUOTA_SUCCESS,
          payload: res,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_QUOTA_ERROR,
        });
      });
  };

export const close3DayTrialModal = ({ params = {} } = {}) =>
  AXIOS_INSTANCE.request({
    url: `${QT_API}/quota/${params.orgCode}/update-quota-alert?functionCode=${params.functionCode}`,
    method: "POST",
  });
